import { FlaskConical } from "lucide-react";
import { isUiSandboxEnabled } from "@/dev/uiSandbox";

export function UiSandboxBadge() {
  if (!isUiSandboxEnabled) return null;

  return (
    <div className="fixed bottom-4 right-4 z-[100] flex items-center gap-2 rounded-full border border-violet-300 bg-violet-50 px-3 py-2 text-xs font-semibold text-violet-800 shadow-lg dark:border-violet-700 dark:bg-violet-950 dark:text-violet-200">
      <FlaskConical className="h-4 w-4" />
      UI Sandbox · fictional data
    </div>
  );
}
